import { FC } from 'react';
import { FAIcon, GenericLink, NextgenImage, IconStyle, Theme } from '@nextgen-web-framework/all';
import type { BottomNavigationItemsProps } from './types/propsTypes';
import { BottomNavigationItemType } from './types/propsTypes';
import styles from './BottomNavigationItems.module.scss';

const BottomNavigationItems: FC<BottomNavigationItemsProps> = ({ label, url, activeRoute, type, icon, image }) => {
  const isActivePage = activeRoute === url;

  const renderImage = () => (
    <div className={styles['bottom-navigation-logo-container']}>
      {image && <NextgenImage src={`${isActivePage ? image?.activeImageUrl : image?.inactiveImageUrl}`} alt={label} />}
    </div>
  );

  const renderIcon = () => (
    <div data-testid="generic-link-selected-test-id" className={styles['icon-container']}>
      {icon && (
        <FAIcon
          iconName={icon}
          iconStyle={isActivePage ? IconStyle.SOLID : IconStyle.REGULAR}
          theme={isActivePage ? Theme.PURPLE : Theme.GRAY}
          className={`fa-fw ${styles['bottom-navigation-icon-styles']} ${
            isActivePage ? styles['bottom-navigation-icon-selected-styles'] : ''
          }`}
        />
      )}
    </div>
  );

  const renderButton = () => {
    switch (type) {
      case BottomNavigationItemType.Image: {
        return renderImage();
      }
      case BottomNavigationItemType.Icon: {
        return renderIcon();
      }
      default: {
        return <></>;
      }
    }
  };

  return (
    <li
      className={` ${styles['mobile-footer-item']} ${isActivePage ? styles['bottomNavigationItemSelected'] : ' '}`}
      data-testid="mobile-footer-item-test-id"
    >
      <GenericLink href={url} forceNative={false}>
        <div>
          {renderButton()}
          <span className={styles['mobile-footer-item-label']} data-testid="mobile-footer-label-test-id">
            {label}
          </span>
        </div>
      </GenericLink>
    </li>
  );
};

export default BottomNavigationItems;
export { BottomNavigationItemType };
